import { Loader } from 'https://cdn.pika.dev/google-maps'

console.log("Loading store locator...")

class StoreLocator extends HTMLElement {
    constructor() {
        super()

        this.key = this.getAttribute('data-key')
        this.filter = ''
        this.init()
    }

    async getStoresFromCSV() {
        this.stores = []

        try {
            let response = await fetch(this.getAttribute('data-csv-url'))
            let csvData = await response.text()

            const jsonData = await new Promise((resolve, reject) => {
                Papa.parse(csvData, {
                    header: true,
                    complete: (result) => resolve(result.data),
                    error: (error) => reject(new Error('Error al parsear el CSV: ' + error.message))
                })
            })

            this.stores = Array.from(jsonData).map((store) => {
                let parsedStore = {
                    name: store.store_name ?? '',
                    province: store.province ?? '',
                    city: store.city ?? '',
                    address: store.address ?? '',
                    socialMediaUrl: store.social_media_url?.split(',') ?? [],
                    socialMediaName: store.social_media_name?.split(',') ?? [],
                    lat: store.latitude ?? '',
                    lng: store.longitude ?? '',
                    key: `${store.store_name?.toLowerCase().replace(/[^\w\s]/g, '').replace(/\s+/g, '-').trim()}-${store.latitude}-${store.longitude}` ?? '',
                }

                return parsedStore
            })            
        }catch(error) {
            console.log('Error al obtener el archivo CSV: ', error)
        }
    }

    async initGoogleMaps() {
        const loader = new Loader(this.key, { libraries: ['places'] })

        const google = await loader.load()
        this.mapInstance = new google.maps.Map(this.querySelector('#StoreLocatorMap'), {
            center: { lat: -34.62527196729551, lng: -58.37543320682179 },
            zoom: 6,
            disableDefaultUI: true,
            zoomControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
        })

        this.markers = this.stores.map(store => {
            const marker = new google.maps.Marker({
                position: { lat: Number(store.lat), lng: Number(store.lng) },
                map: this.mapInstance,
                icon: { 
                    url: "https://cdn.shopify.com/s/files/1/0293/1317/1504/files/map-marker-svgrepo-com.svg?v=1752587607",
                    scaledSize: new google.maps.Size(40, 52)
                }
            })

            marker.store = store

            marker.addListener('click', () => {
                this.selectStore(store)
            })

            return marker
        })
    }

    renderStoreList() {
        this.storeList = this.querySelector('#StoreLocatorStores')

        const data = this.stores.map(store => {   
            const socialLinks = store.socialMediaUrl.map((url, index) => {
                return `<a href="${url}" target="_blank">${store.socialMediaName[index]}</a>`;
            }).join(', ');

            return `
                <div class="store-locator__store" 
                  data-name="${store.name}" 
                  data-address="${store.address}" 
                  data-province="${store.province}" 
                  data-city="${store.city}" 
                  data-key=${store.key}
                >
                    <h3 class="store-locator__store-title">${store.name}</h3>
                    <div class="store-locator__store-info">
                        <p>${store.name}</p>
                        <p>Dirección: ${store.address}</p>
                        <p>Localidad: ${store.city}</p>
                        <p>Redes: ${socialLinks}</p>
                    </div>
                    <button class="store-locator__btn">
                        <div class="store-locator__btn-direction store-locator__btn-direction--normal">
                            <span>Ver en el mapa</span>
                            <svg xmlns="http://www.w3.org/2000/svg" stroke-linecap="square" stroke-linejoin="arcs" aria-hidden="true" class="icon-theme icon-theme-stroke icon-core-chevron-right" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg>
                        </div>
                        <div class="store-locator__btn-direction store-locator__btn-direction--active">
                            <svg xmlns="http://www.w3.org/2000/svg" stroke-linecap="square" stroke-linejoin="arcs" aria-hidden="true" class="icon-theme icon-theme-stroke icon-core-chevron-left" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg>
                            <span>Volver</span>
                        </div>
                    </button>
                </div>
            `
        })

        this.storeList.innerHTML = data.join('');
    }

    updateMapPosition(latLng, zoom = 15) {
        this.mapInstance.setOptions({ center: latLng, zoom: zoom })
    }

    selectStore(selectedStore) {
        Array.from(this.storeList.children).forEach(store => {
            if(selectedStore.key === store.dataset.key) {
                store.classList.remove('hidden')
                store.classList.add('active')

            }else {
                store.classList.add('hidden')
            }
        })

        this.updateMapPosition({ lat: Number(selectedStore.lat), lng: Number(selectedStore.lng) })
    }

    setListeners() {
        this.filterForm = this.querySelector('#StoreLocatorForm');

        this.filterForm.addEventListener('submit', (event) => {
            event.preventDefault();
            this.filter = this.filterForm.querySelector('input').value.toLowerCase().trim();
            this.filterStore();
            this.filter = '';
        })

        Array.from(this.storeList.children).forEach(store => {
            const btnDirection = store.querySelector('.store-locator__btn');
                
            if(!!!btnDirection) return
            
            btnDirection.addEventListener('click', event => {
                if(store.classList.contains('active')) {
                    store.classList.remove('active')
                    this.storeList.children[0].classList.remove('hidden')
                    this.filterForm.dispatchEvent(new Event('submit'))
                    this.mapInstance.setOptions({ zoom: 6 })
                } else {
                    const selectedStore = this.stores.find(storeObject => storeObject.key === store.dataset.key)
                    if(!!selectedStore) {
                        this.selectStore(selectedStore)
                    }
                }
            })
        })
    }

    filterStore() {
        Array.from(this.storeList.children).forEach((item) => {
            const province = item.dataset.province.toLowerCase();
            const city = item.dataset.city.toLowerCase();
            const name = item.dataset.name.toLowerCase();

            const isVisible = this.filter === '' || name.includes(this.filter) || province.includes(this.filter) || city.includes(this.filter);

            if (isVisible) {
                item.classList.remove('hidden');
            } else {
                item.classList.add('hidden');
            }
        });
    }
    
    async init() {
        await this.getStoresFromCSV()
        await this.initGoogleMaps()
        this.renderStoreList()
        this.setListeners()
    }
}

customElements.define('store-locator', StoreLocator)